import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _debounce from 'lodash/debounce'

import App from '../App'

import useStyles from './styles'


const Layout = (props) => {
  const classes = useStyles()
  const { children, header, footer, className, seo } = props

  // effects
  useEffect(() => {
    const recalcVH = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    }
    const debouncedRecalvVH = _debounce(recalcVH, 100)
    // exectute once and on resize

    recalcVH()
    window.addEventListener('resize', debouncedRecalvVH)
    // cleanup
    return () => {
      window.removeEventListener('resize', debouncedRecalvVH)
    }
  })

  return (
    <App seo={seo}>
      <div className={cx(classes.container, className)}>
        <>{header}</>
        <>{children}</>
        <>{footer}</>
      </div>
    </App>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
  seo: PropTypes.objectOf(PropTypes.string),
}
Layout.defaultProps = {
  header: null,
  footer: null,
  className: null,
  seo: {},
}

export default Layout
